export default __webpack_public_path__ + "static/media/card-pos.b0d1a27c.svg";